import { createAction, props } from '@ngrx/store';
import { HttpErrorResponse } from '@angular/common/http';
import { CandidateDna } from '@app/modules/authenticated-view/modules/vanguard-view/dna-profile/models/dna-profile.model';
import { DnaJobApplication } from '@app/modules/authenticated-view/modules/vanguard-view/dna-profile/models/dna-job-application.model';

export const loadCandidateDna = createAction('[Candidate DNA] Load', props<{ id: number }>());

export const loadCandidateDnaSuccess = createAction(
  '[Candidate DNA] Load Success',
  props<{ dna: CandidateDna }>(),
);

export const loadCandidateDnaError = createAction(
  '[Candidate DNA] Load Error',
  props<{ error: HttpErrorResponse }>(),
);

export const loadCandidateDnaApplications = createAction('[Candidate DNA] Load Applications');

export const loadCandidateDnaApplicationsSuccess = createAction(
  '[Candidate DNA] Load Applications Success',
  props<{ applications: DnaJobApplication[] }>(),
);

export const loadCandidateDnaApplicationsError = createAction(
  '[Candidate DNA] Load Applications Error',
  props<{ error: HttpErrorResponse }>(),
);
